import type { ReactNode, SVGProps } from "react";
import { useTranslation } from "react-i18next";

/** Етикетът на секция („КОГА", „ГОСТИ", „МАСИ *") — eyebrow стил. */
export const SectionLabel = ({ children, required = false }: { children: ReactNode; required?: boolean }) => (
  <div className="text-[10.5px] font-bold uppercase leading-[1.2] tracking-[1.2px] text-muted">
    {children}
    {required && <span className="ml-0.5 text-danger-ink">*</span>}
  </div>
);

/** Ръчичката „кликни" (банерът на избора и празното поле „Маси"). */
export const HandPointerIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round" aria-hidden {...props}>
    <path d="M9 11V5.5a1.5 1.5 0 0 1 3 0V10" />
    <path d="M12 9.5a1.5 1.5 0 0 1 3 0V11" />
    <path d="M15 10.5a1.5 1.5 0 0 1 3 0V14a6 6 0 0 1-6 6h-.6a6 6 0 0 1-4.7-2.3l-2.3-3a1.6 1.6 0 0 1 2.4-2.1L9 14" />
  </svg>
);

/** Звездичката на „Предложи маса". */
export const StarIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinejoin="round" aria-hidden {...props}>
    <path d="m12 3.5 2.6 5.3 5.9.9-4.3 4.1 1 5.8L12 16.9l-5.2 2.7 1-5.8-4.3-4.1 5.9-.9z" />
  </svg>
);

/** „☆ Предложи маса" — до етикета „МАСИ *"; `tall` — височина за пръст (телефон). */
export const SuggestTableButton = ({ onClick, tall = false }: { onClick: () => void; tall?: boolean }) => {
  const { t } = useTranslation();
  return (
    <button
      type="button"
      onClick={onClick}
      className={`flex cursor-pointer items-center gap-1.5 rounded-md border-none bg-transparent px-1.5 ${tall ? "min-h-10 py-2" : "py-1"} text-[12.5px] font-bold text-brand-deep-ink transition-colors duration-150 hover:bg-brand-tint`}
    >
      <StarIcon className="size-3.5" />
      {t("reservations.form.suggest")}
    </button>
  );
};
